import React from 'react';
import { HStack, Icon, Select } from '@chakra-ui/react';
import { FiGlobe } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';
import apiClient from '../services/apiClient';

// Language picker for the admin app. Saves the choice locally and (best effort)
// to the user's profile, which the staff app and server-rendered emails/PDFs use.
const LanguageMenu = () => {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  const change = async (code) => {
    await i18n.changeLanguage(code);
    try {
      await apiClient.patch('/auth/me/', { preferred_language: code });
    } catch { /* UI already switched; profile sync is best effort */ }
  };

  return (
    <HStack spacing={2} mb={3}>
      <Icon as={FiGlobe} boxSize={4} color="gray.500" />
      <Select
        size="sm"
        value={current}
        onChange={(e) => change(e.target.value)}
        aria-label={t('languageMenu.label', 'Language')}
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.nativeLabel === l.label ? l.label : `${l.nativeLabel} (${l.label})`}
          </option>
        ))}
      </Select>
    </HStack>
  );
};

export default LanguageMenu;
